import React, { useEffect, useState } from "react";
import { Layout } from "antd";
const { Sider } = Layout;



import Banners from "./Banners";
import Transactions from "./Transactions";
import Balance from "./Balance";
import Exchange from "./Exchange";
import WhatsAppNumbers from "./WhatsAppNumbers";
import ScrollToTop from "./scrollToTop";
import DrawerRightSide from "./drawerRightSideVersion";
import useResponsiveWidth from "hooks/useResponsiveWidth";

const Index: React.FC= () => {
    const responsiveWidth = useResponsiveWidth();
   
    return (
        <>
            {/*{*/}
            {/*    responsiveWidth < 1280 ?*/}
            <DrawerRightSide />
            {/*:*/}
            {/*        /!*<Sider width={240} theme='light' className='ant-layout-sider-transparent right_sidebar ' >*!/*/}

            {/*            <Banners />*/}

            {/*            <Transactions />*/}

            {/*            <Balance />*/}

            {/*            <Exchange />*/}

            {/*            <WhatsAppNumbers />*/}

            {/*            <ScrollToTop />*/}

            {/*        </Sider>*/}
            {/*}*/}
        </>
    )
}

export default Index;
